export enum PaymentTermName {
  COD = 'COD',
  Net15 = 'NET15',
  Net30 = 'NET30',
  Net45 = 'NET45',
  Net60 = 'NET60'
}